// Use the exact same official sprite marks as CarCard everywhere.

import type { SVGProps } from "react";
import { DsIcon } from "@/components/ui/ds-icons";

export type RentalTypeKey = "driving" | "chauffeured" | "event";

/** Collapse the various stored rental-type spellings to one of three keys. */
export function normalizeRentalType(rentalType: string | null | undefined): RentalTypeKey {
  const rt = (rentalType || "").toLowerCase();
  if (rt === "chauffeured" || rt === "chauffeur") return "chauffeured";
  if (rt === "event" || rt === "events") return "event";
  return "driving";
}

/** i18n key for the human label under `common.rental_types.*`. */
export function rentalTypeI18nKey(rentalType: string | null | undefined): string {
  const key = normalizeRentalType(rentalType);
  if (key === "chauffeured") return "common.rental_types.chauffeured";
  if (key === "event") return "common.rental_types.event";
  return "common.rental_types.self_drive";
}

/** Renders the correct rental-type glyph for a stored rental type. */
export function RentalTypeIcon({
  rentalType,
  ...props
}: { rentalType: string | null | undefined } & SVGProps<SVGSVGElement>) {
  const key = normalizeRentalType(rentalType);
  return <DsIcon {...props} name={key === "chauffeured" ? "chauffeured" : key === "event" ? "event-rental" : "driveable"} />;
}
